import axios from "axios";
import jwtDecode from "jwt-decode";
import { useEffect, useState, createContext, useContext } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import "./Institution.scss";
import { MyContext } from "./Certified";
import Swal from "sweetalert2";
function Institution() {
  let navigate = useNavigate();
  const decodedToken = jwtDecode(window.sessionStorage.getItem("token"));
  const { state } = useLocation();
  // 회원정보 State
  const [memberData, setMemberData] = useState([]);
  // const [id, setId] = useState("");
  // const [busNum, setBusNum] = useState("");
  // const [companyName, setCompanyName] = useState("");
  // const [ceo, setCeo] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [taxEmail, setTaxEmail] = useState("");

  // 실무자 정보 입력
  const [staffName, setStaffName] = useState("");
  const [staffPosition, setStaffPosition] = useState("");
  const [staffEmail, setStaffEmail] = useState("");
  const [staffNum, setStaffNum] = useState("");

  const [staffList, setStaffList] = useState([]);
  // 회원정보 데이터 받기
  const getUserData = async () => {
    try {
      const response = await axios.get(`/api/applicant/${decodedToken.sub}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      setMemberData(response.data);
      if (response.data.staffName2 === "") {
        setStaffList([response.data.staffName1]);
      } else {
        setStaffList([response.data.staffName1, response.data.staffName2]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  // 회원정보입력 Handler
  const onChangeHandler = (event) => {
    const eventId = event.target.id;

    // if (eventId === "bus_num") {
    //   setBusNum(event.target.value);
    // }
    // if (eventId === "co_name") {
    //   setCompanyName(event.target.value);
    // }
    // if (eventId === "ceo") {
    //   setCeo(event.target.value);
    // }
    // if (eventId === "phone_num") {
    //   setPhoneNum(event.target.value);
    // }
    // if (eventId === "ceo_email") {
    //   setTaxEmail(event.target.value);
    // }
    if (eventId === "staffName") {
      setStaffName(event.target.value);
    }
    if (eventId === "staffPosition") {
      setStaffPosition(event.target.value);
    }
    if (eventId === "staffEmail") {
      setStaffEmail(event.target.value);
    }
    if (eventId === "staffNum") {
      setStaffNum(event.target.value);
    }
  };

  // 실무자 정보 입력 SelectBox
  const staffSelectHandler = (event) => {
    if (event.target.value === "0") {
      setStaffName(memberData.staffName1);
      setStaffPosition(memberData.staffPosition1);
      setStaffEmail(memberData.staffEmail1);
      setStaffNum(memberData.staffTelNum1);
    }
    if (event.target.value === "1") {
      setStaffName(memberData.staffName2);
      setStaffPosition(memberData.staffPosition2);
      setStaffEmail(memberData.staffEmail2);
      setStaffNum(memberData.staffTelNum2);
    }
    if (event.target.value === "직접입력") {
      setStaffName("");
      setStaffPosition("");
      setStaffEmail("");
      setStaffNum("");
    }
  };

  // 다음 페이지
  const goNext = () => {
    state.form = {
      telNum: memberData.telNum,
      taxEmail: memberData.taxEmail,
      staffName,
      staffPosition,
      staffEmail,
      staffNum,
    };
    if (
      staffName === "" ||
      staffPosition === "" ||
      staffEmail === "" ||
      staffNum === ""
    ) {
      Swal.fire({
        icon: "error",
        title: "오류",
        text: "실무자 정보를 입력하세요",
        confirmButtonColor: "dodgerBlue",
      });
    } else {
      navigate("/request/authinfo", {
        state,
      });
    }
  };
  useEffect(() => {
    if (state?.prevData?.applyFormValues?.length > 0) {
      setStaffName(state.prevData.managerName);
      setStaffPosition(state.prevData.managerDuty);
      setStaffEmail(state.prevData.managerEmail);
      setStaffNum(state.prevData.managerTel);
    }
    getUserData();
  }, []);
  return (
    <>
      <div className="step1_institution">
        <div className="contain my_institution_wrap">
          <form className="my_institution" action="" method="">
            <h1 className="my_institution_heading">
              {state.id[0].workflowName}
              {state.acceptNum === undefined ? (
                <>
                  {state.id[0].type === 9
                    ? " 이의·불만·분쟁 처리 신청"
                    : "신청(기관정보)"}
                </>
              ) : (
                <span style={{ marginLeft: "1rem" }}>
                  지위승계 접수번호 : {state.acceptNum}
                </span>
              )}
            </h1>
            <div className="row">
              <div className="col">
                <div className="input_row">
                  <div className="input_col">
                    <label htmlFor="id">아이디</label>
                    <div className="input_wrap">
                      <input
                        id="id"
                        className="input_line"
                        type="text"
                        placeholder="아이디"
                        value={memberData.id || ""}
                        disabled
                        style={{ opacity: 0.5 }}
                      />
                    </div>
                  </div>
                  <div className="input_col"></div>
                </div>
                <div className="input_row">
                  <div className="input_col">
                    <label htmlFor="bus_num">사업자등록번호</label>
                    <div className="input_wrap">
                      <input
                        id="bus_num"
                        className="input_line"
                        type="text"
                        value={memberData.companyRegNum || ""}
                        disabled
                        style={{ opacity: 0.5 }}
                      />
                    </div>
                  </div>
                  <div className="input_col">
                    <label htmlFor="co_name">회사명</label>
                    <div className="input_wrap">
                      <input
                        id="co_name"
                        className="input_line"
                        type="text"
                        value={memberData.companyName || ""}
                        disabled
                        style={{ opacity: 0.5 }}
                      />
                    </div>
                  </div>
                  <div className="input_col">
                    <label htmlFor="ceo">대표자명</label>
                    <div className="input_wrap">
                      <input
                        id="ceo"
                        className="input_line"
                        type="text"
                        value={memberData.ceoName || ""}
                        disabled
                        style={{ opacity: 0.5 }}
                      />
                    </div>
                  </div>
                </div>
                <div className="input_row">
                  <div className="input_col">
                    <label htmlFor="phone_num">연락처</label>
                    <div className="input_wrap">
                      <input
                        id="phone_num"
                        className="input_line"
                        type="tel"
                        value={memberData.telNum || ""}
                        disabled
                        style={{ opacity: 0.5 }}
                      />
                    </div>
                  </div>
                  <div className="input_col">
                    <label htmlFor="ceo_email">세금계산서 수신 이메일</label>
                    <div className="input_wrap">
                      <input
                        id="ceo_email"
                        className="input_line"
                        type="email"
                        value={memberData.emailForTax || ""}
                        disabled
                        style={{ opacity: 0.5 }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="working_person_info">
                <h1>
                  <span>인증 신청 실무자 정보 입력</span>
                </h1>
                <div className="select_box">
                  <select onChange={staffSelectHandler}>
                    <option value="직접입력">직접입력</option>
                    {staffList.map((e, idx) => (
                      <option key={idx} value={idx}>
                        {e}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col">
                <div className="input_row">
                  <div className="input_col">
                    <div className="input_wrap">
                      <input
                        id="staffName"
                        className="input_line"
                        type="text"
                        placeholder="실무자이름"
                        onChange={onChangeHandler}
                        value={staffName || ""}
                      />
                    </div>
                  </div>
                  <div className="input_col">
                    <div className="input_wrap">
                      <input
                        id="staffPosition"
                        className="input_line"
                        type="text"
                        placeholder="직책"
                        onChange={onChangeHandler}
                        value={staffPosition || ""}
                      />
                    </div>
                  </div>
                  <div className="input_col">
                    <div className="input_wrap">
                      <input
                        id="staffEmail"
                        className="input_line"
                        type="email"
                        placeholder="이메일"
                        onChange={onChangeHandler}
                        value={staffEmail || ""}
                      />
                    </div>
                  </div>
                  <div className="input_col">
                    <div className="input_wrap">
                      <input
                        id="staffNum"
                        className="input_line"
                        type="text"
                        placeholder="실무자 연락처"
                        onChange={onChangeHandler}
                        value={staffNum || ""}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="input_wrap submit_btn">
                {state.id[0].beforeId !== undefined ||
                state.acceptNum !== undefined ? (
                  <button
                    className="btn_line"
                    onClick={() => {
                      navigate(`/breakdown/cits`);
                    }}
                  >
                    나의신청내역
                  </button>
                ) : null}
                <button
                  className="btn_line"
                  onClick={() => {
                    navigate(`/certified/${state.id[0].id}`, { state });
                  }}
                >
                  취소
                </button>
                <button type="button" className="btn_color" onClick={goNext}>
                  다음
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Institution;
